// categoriesApi.js
import { baseApi } from '../baseApi';

export const reportsApi = baseApi.injectEndpoints({
  reducerPath: 'reportsApi',
  endpoints: (builder) => ({
    getReportReasons: builder.query({
      query: () => '/report/report-reasons', // Endpoint for GET /api/categories
    }),
    reportListing: builder.mutation({
      query: (reportData) => ({
        url: '/report/listing',
        method: 'POST',
        body: reportData,
      }),
    }),
    reportUser: builder.mutation({
      query: (reportData) => ({
        url: '/report/user',
        method: 'POST',
        body: reportData,
      }),
    }),
    // You can add more endpoints for categories here if needed
  }),
});

export const {
  useGetReportReasonsQuery,
  useReportListingMutation,
  useReportUserMutation, // Export the auto-generated hook for the getCategories query
  // Add other exported hooks here as you create more endpoints
} = reportsApi;
